import { RelacionComprobante } from "./relacion-comprobante";
import { RelacionSucursales } from "./relacion-sucursales";

export class Usuario {
    public nombreCompleto: string;
    public password: string;
    public passwordComparar?: string;
    public correoElectronico?: string;
    public img?: string;
    public rolId: string;
    public google?: boolean;
    public _id: string;
    public companiaId: string;
    public grupoCia: string;
    //public imagenFondo: string;
    //public inventario: boolean;
    public esAdministrador?: boolean;
    public createdAt: Date;    
    public relacionComprobantes: RelacionComprobante[] = [];
    public relacionSucursales: RelacionSucursales[] = [];

    constructor(usuario?) {
        usuario = usuario || {};
        this.nombreCompleto = usuario.nombreCompleto;
        this.password = usuario.password;
        this.passwordComparar = usuario.passwordComparar;
        this.correoElectronico = usuario.correoElectronico;
        this.companiaId = '';
     }
}
